import React from "react";
import { useDispatch } from "react-redux";

import { HamburgerIcon } from "@chakra-ui/icons";
import { Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Td, Text, Tr, useColorModeValue } from "@chakra-ui/react";
import moment from "moment";

import { removeOwnerDocumentAsync } from "../../redux/user/userSlice";
import { API } from "../../utils/http";
function OwnerDocumentsTableRow(props) {
	const { document, ownerEmail } = props;
	console.log("row: ", document);
	const dispatch = useDispatch();
	const textColor = useColorModeValue("gray.700", "white");
	const deleteDocument = (documentId) => {
		const payload = { documentId, ownerEmail };
		// console.log("delete: ", { documentId, propertyId });
		dispatch(removeOwnerDocumentAsync(payload));
	};
	const getDocument = (documentId, documentName) => {
		const payload = { documentId, ownerEmail, documentName };
		console.log("view: ", payload);
		API.put("get-owner-document-url", payload).then((r) => {
			console.log(r);
			window.open(r.data.url, "_blank");
		});
	};

	return (
		<Tr>
			<Td minWidth={{ sm: "200px" }}>
				<Flex py=".8rem" direction={"column"}>
					<Text fontSize="md" color={textColor} fontWeight="bold">
						{moment(document?.addedDate).format("DD MMM YYYY HH:mm")}
					</Text>
				</Flex>
			</Td>
			<Td>
				<Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
					{document?.name}
				</Text>
			</Td>
			<Td>
				<Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
					{document?.type}
				</Text>
			</Td>
			<Td>
				<Menu closeOnSelect={false}>
					<MenuButton>
						<Icon as={HamburgerIcon} />
					</MenuButton>
					<MenuList>
						<MenuItem
							onClick={() => {
								getDocument(document.id, document.name);
							}}
						>
							Download
						</MenuItem>
						<MenuItem
							onClick={() => {
								deleteDocument(document.id);
							}}
						>
							Delete
						</MenuItem>
					</MenuList>
				</Menu>
				{/* <Stack direction="row">
					<Button
						onClick={() => {
							getDocument(row.id);
						}}
					>
						<Tooltip label="Download">
							<Icon as={DownloadIcon} color={"teal.400"} boxSize={6}></Icon>
						</Tooltip>
					</Button>
					<Button
						colorScheme={"red"}
						onClick={() => {
							deleteDocument(row.id);
						}}
					>
						<Tooltip label="Download">
							<Icon as={DeleteIcon} boxSize={6}></Icon>
						</Tooltip>
					</Button>
				</Stack> */}
			</Td>
		</Tr>
	);
}

export default OwnerDocumentsTableRow;
